export class ServerWithSummarize {
    constructor(hostName, pingIndex, averageDownloadSpeed, maxDownloadSpeed){ 
        this.hostName = hostName;
        this.pingIndex = pingIndex;
        this.averageDownloadSpeed = averageDownloadSpeed;
        this.maxDownloadSpeed = maxDownloadSpeed;
    }
}